var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('solid-primary-button',_vm._g(_vm._b({on:{"click":_vm.resendActivationEmail}},'solid-primary-button',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$tc('resendActivationEmail'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }